import { store } from '@/store';
import { getCurrentUser } from '@/helpers/store'
import Vue from 'vue';
export default {
    user_putusers(data, vue) {
        if (data.data && data.data.id) {
            vue.$root.$emit('update-user-form', data.data.id);
            store.dispatch('users/getUser', data.data.id).then(user => {
                store.state.users.users.map((item, index) => {
                    if (user && item && parseInt(user.id) == parseInt(item.id))
                        store.commit('setStateObject', ['users.users.' + index, user]);
                });
            });
        }
    },
    user_addusers(data, vue) {
        if (data && data.data && data.data.id && store.state.users.users && parseInt(store.state.users.currentUsersPage) === 1) {
            //Если запрос обновления делал текущий пользователь, то добавлять пользователя в спитсок не надо
            if (
                vue.$store.state.users && vue.$store.state.users.current && vue.$store.state.users.current.id &&
                data.user && data.user.id && parseInt(data.user.id) === parseInt(vue.$store.state.users.current.id)
            ) return;
          store.dispatch('users/getUser', data.data.id).then(user => store.commit('users/unshiftUser', user));
        }
    },
    async user_removeusers({ data }, vue) {
        if (store.state.users.users && data && data.id) {
            store.state.users.users.map((user, index) => {
              if (user && data && user.id == data.id)
                store.commit('deleteStateObject', ['users.users', index]);
            });
        }

        const user = getCurrentUser(vue)
        if (user && data && user.id === data.id) {
            alert('Ваша учётная запись удалена администратором. Вы будете перенаправлены на страницу авторизации');
            await vue.$store.dispatch('users/logout');
            vue.$router.push({name: 'Login'});
        }
    },
    async user_blockusers({ data }, vue) {
        const user = getCurrentUser(vue)
        if (user && data && user.id === data.user_id) {
            alert('Ваша учётная запись заблокированна администратором. Вы будете перенаправлены на страницу авторизации');
            await vue.$store.dispatch('users/logout');
            vue.$router.push({name: 'Login'});
        }
    },
    async user_authoff({ data }, vue) {
        const user = getCurrentUser(vue)
        if (user && data && user.id === data.user_id) {
            alert('Ваша сессия сброшена администратором. Вы будете перенаправлены на страницу авторизации');
            await vue.$store.dispatch('users/logout');
            vue.$router.push({name: 'Login'});
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/users/pusher.js